import React, { useState, useEffect, createRef } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Card from "../../components/Card/Card";
import CardBody from "../../components/Card/CardBody";
import Grid from "@material-ui/core/Grid";
import "./Document.css";
import { DirectUpload } from "@rails/activestorage";
import avtar from "../../assets/img/document1.png";
import baseUrl from "../../utils/baseUrl";
import "../../components/toast.css";
import { getRequest } from "../../api/Api";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";

const styles = theme => ({
  root: {
    padding: "16px",
  },
});
const useStyles = makeStyles(styles);

class Uploader {
  constructor(file, url, index) {
    this.file = file;
    this.url = url;
    this.index = index;
    this.uploadObj = new DirectUpload(this.file, this.url, this);
    this.progressElement = document.getElementById(
      `direct-upload-${this.index}`,
    );
    this.progressBar = document.getElementById(
      `direct-upload-progress-${this.index}`,
    );
  }

  upload(file) {
    return new Promise((resolve, reject) => {
      this.uploadObj.create((error, blob) => {
        if (error) {
          this.progressElement.classList.add("direct-upload--error");
          this.progressElement.setAttribute("title", error);
          reject(error);
        } else {
          this.progressElement.classList.add("direct-upload--complete");
          const hiddenField = document.createElement("input");
          hiddenField.setAttribute("type", "hidden");
          hiddenField.setAttribute("value", blob.signed_id);
          /* Add a map which has an object of the pattern, {"prescription": [key1, 
          key2], "pathology": [key1, key2], ...}, remember to delete from the array____ 
          this will be for the final implementation where we abstract this into a single class */

          // state: [index1, index2, ...] remember to delete the appropriate index
          // when the associated file is deleted, initialize this array with zero
          // hiddenField.id = `document_${this.index}`;
          hiddenField.setAttribute("class", `document_`);
          document.querySelector("form").appendChild(hiddenField);
          resolve("Success");
        }
      });
    });
  }

  directUploadDidProgress(event) {
    this.progressBar.style.width = `${(100 * event.loaded) / event.total}%`;
  }

  directUploadWillStoreFileWithXHR(request) {
    this.progressElement.classList.remove("direct-upload--pending");
    request.upload.addEventListener("progress", event =>
      this.directUploadDidProgress(event),
    );
  }
}
// const { forwardRef, useImperativeHandle } = React;
const UploadDocument = props => {
  const { patientid, visitid, handleCount } = props;

  const classes = useStyles();
  const [list, setList] = useState([]);
  const [acceptedData, setAcceptedData] = useState([]);

  const fetchDocumentTitle = () => {
    const token = "Bearer " + localStorage.getItem("jwt");
    getRequest("get_patient_document_type_list", token).then(data => {
      if (data.error) {
        console.log(data.error);
      } else {
        setList(data[2]);
      }
    });
  };

  useEffect(() => {
    fetchDocumentTitle();
  }, []);

  const fileInput = createRef();
  // console.log(fileInput);
  const addProgressBar = (file, index, handler) => {
    handler.insertAdjacentHTML(
      "afterend",
      `<br/>
     <div id="direct-upload-${index}" class="direct-upload direct-upload--pending">
     <div id="direct-upload-progress-${index}" class="direct-upload__progress" 
     style="width: 0%"></div>
     <span class=direct-upload__filename">${file.name}</span>
     </div>`,
    );
  };

  var temp = [];
  const differenceOf2Arrays = (array1, array2) => {
    for (var i in array1) {
      if (array2.indexOf(array1[i]) === -1) temp.push(array1[i]);
    }
    for (i in array2) {
      if (array1.indexOf(array2[i]) === -1) temp.push(array2[i]);
    }
    return temp.sort((a, b) => a - b);
  };

  const handleFiles = formData => {
    return new Promise((resolve, reject) => {
      const promises = [];
      for (let i = 0; i < fileInput.current.files.length; i++) {
        addProgressBar(fileInput.current.files[i], i, fileInput.current);
        if (fileInput.current.files[i].size <= 10000000) {
          promises.push(uploadFiles(fileInput.current.files[i], i));
        } else {
          alert(
            `Your file ${fileInput.current.files[i].name} was not uploaded because it exceeds the 10 MB size limit.`,
          );
        }
      }
      Promise.all(promises)
        .then(() => {
          var patientPrescription = document.getElementsByClassName(
            `document_`,
          );
          var prescriptionFiles = [];
          for (let i = 0; i < patientPrescription.length; i++) {
            setAcceptedData(prevAcceptedData => [
              ...prevAcceptedData,
              patientPrescription[i].value,
            ]);
            prescriptionFiles.push(patientPrescription[i].value);
          }
          console.log(prescriptionFiles);
          console.log(acceptedData);
          differenceOf2Arrays(prescriptionFiles, acceptedData);
          var pr = [];
          for (let i = 0; i < temp.length; i++) {
            pr.push({
              documents: temp[i],
              visit_id: visitid,
              document_type: list.key,
            });
            Object.keys(pr[i]).forEach(key => {
              formData.append(
                `patient[patient_documents_attributes][${i}][${key}]`,
                pr[i][key],
              );
            });
          }
        })
        .then(() => resolve("looped through all files!"))
        .catch(error => reject(error));
    });
  };

  const uploadFiles = (file, index) => {
    return new Promise((resolve, reject) => {
      const URL = `${baseUrl}/rails/active_storage/direct_uploads`;
      new Uploader(file, URL, index)
        .upload(file)
        .then(message => resolve(message))
        .catch(error => reject(error));
    });
  };

  const handle = event => {
    var formData = new FormData();

    handleFiles(formData)
      .then(message => {
        console.log(acceptedData);
        console.log(patientid);
        if (
          localStorage.getItem("jwt") !== "" ||
          localStorage.getItem("jwt") !== undefined
        ) {
          let token = "Bearer " + localStorage.getItem("jwt");
          fetch(`${baseUrl}/save_patient_documents/${patientid}`, {
            method: "PUT",
            headers: {
              Authorization: token,
            },
            body: formData,
          }).then(response => {
            response.json().then(data => {
              if (response.status === 200) {
                toast(<p>{data.message}</p>, {
                  className: "custom",
                  autoClose: 1000,
                });
                setTimeout(() => {
                  // setAcceptedData([])
                }, 1000);
                handleCount();
              } else {
                toast.error(<p>{data.error}</p>, { autoClose: 3000 });
              }
            });
          });
        }
      })
      .catch(error => {
        alert(error);
      });
  };

  return (
    <div className={classes.root} style={{ marginTop: "-20px" }}>
      <Grid>
        <Grid item xs={12} sm={12} md={12}>
          <Card
            style={{
              marginTop: "14px",
              boxShadow:
                "0 2px 8px rgba(0,0,0,0.30), 0 10px 12px rgba(0,0,0,0.22)",
            }}
          >
            <img src={avtar} style={{ height: 165 }} alt="document" />
            <div style={{ textAlign: "center", fontSize: 16, fontWeight: 500 }}>
              <label>Select Prescription</label>
            </div>
            <CardBody>
              <form>
                <Grid item xs={12} sm={12} md={12} container justify="center">
                  <div className="fileUpload">
                  <span style={{ cursor:'pointer' }}>Upload</span>
                    <input
                      type="file"
                      onChange={handle}
                      multiple={true}
                      data_cy ="document-upload-input"
                      className="upload"
                      accept=".pdf,.jpg,.jpeg,.png"
                      ref={fileInput}
                    />
                    
                  </div>
                </Grid>
                <ToastContainer />
                <br />
              </form>
            </CardBody>
          </Card>
        </Grid>
      </Grid>
    </div>
  );
};

export default UploadDocument;
